import React from 'react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import CreateCourseEquivalence from './CreateCourseEquivalence';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;
export default class AddCourse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showAddCourse: true,
            loader: true,
            courseEquivalence: [],
        };
    }
    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');

        element[0].childNodes[1].classList.remove('segment');
    }


    render() {
        return (

            <div>
                {this.state.showAddCourse &&
                <CreateCourseEquivalence/>
                }

                <ToastContainer hideProgressBar />

            </div>

        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamEquivalence/Candidates/CandidatesDetails/AddCourse/AddCourse.js